<div *ngIf="loaded" [innerHtml]="generalSettings.LPHtml | safeHTML"></div>
